import { TranslationString } from 'shared/entities/localization';

export enum EmailDomainPolicyError {
  REGISTRATION_EMAIL_DOMAIN_NOT_ALLOWED = 'registration_email_domain_not_allowed',
  RECOVERY_EMAIL_DOMAIN_NOT_ALLOWED = 'recovery_email_domain_not_allowed'
}

export const mapEmailDomainPolicyErrorToMessage =
  (_code: EmailDomainPolicyError): TranslationString =>
  (t) =>
    t('emailDomainPolicy.errors.registration_email_domain_not_allowed', {
      ns: 'entities'
    });
